import { takeLatest, put, call } from 'redux-saga/effects';
import { USER_TYPES } from '../../types';
import UserActions from '../../actions/user.actions';
import SessionStore from '../../../utils/session-store';
import SessionContext from '../../../utils/session-context';
import EntityService from '../../../api/entity.service';

function getSubmitProfileLink() {
  return function* (options) {
    try {
      // Clear any previous link
      yield put(UserActions.getSubmitProfileLinkSuccess(null));
      
      const token = SessionStore.getSession();
      const userId = SessionContext.get(token).sub;
      const { entityId, entityType } = options.payload;

      const response = yield call(() => EntityService.getSubmitProfileLink(token, entityId, entityType));
      
      const link = response.data[0].url;
      console.log('Extracted link:', link);
      
      yield put(UserActions.getSubmitProfileLinkSuccess(link));
    } catch (error) {
      console.error('Error in getSubmitProfileLink saga:', error);
      yield put(UserActions.getSubmitProfileLinkFailure(error));
    }
  };
}

export const submitProfileLink = getSubmitProfileLink();

export function* submitProfileLinkWatcher() {
  yield takeLatest(USER_TYPES.GET_SUBMIT_PROFILE_LINK_BEGIN, submitProfileLink);
} 